<template>
  <div class="content-container popit">
    <div
      :class="['popit__bg', { 'm-finish': isGameFinished }]"
      :style="isGameFinished ? selectedBackground : ''"
    ></div>
    <div class="popit__content">
      <h1 class="popit__title title">Интерьерный поп-ит</h1>
      <div class="popit__game">
        <popit-game
          :items="items"
          :background="BACKGROUNDS[currentBackground - 1]"
          :is-game-finished="isGameFinished"
          @change="onPopitChange"
        />
      </div>
      <Transition>
        <div class="popit__buttons" v-if="!isGameFinished">
          <button class="button m-gray" @click="onRestartClick">
            начать заново
          </button>
          <button class="button m-gray" @click="onBackgroundChange">
            Выбрать другой дизайн
          </button>
        </div>
      </Transition>
      <Transition>
        <popit-prize
          v-if="isGameAlmostFinished"
          class="popit__prize"
          @click="onPrizeClick"
        />
      </Transition>
    </div>
  </div>
</template>

<script>
import PopitGame from "@/components/games/popit/PopitGame";
import { BACKGROUNDS } from "@/consts/popit";
import audio from "@/assets/audio/pop.mp3";
import Gift from "@/components/Gift";
import PopitPrize from "@/components/PopitPrize";
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "Popit",
  components: { PopitPrize, Gift, PopitGame },
  data() {
    return {
      BACKGROUNDS,
      audio,
    };
  },
  mounted() {
    this.initGame();
  },
  methods: {
    ...mapActions("popitModule", [
      "initGame",
      "restartGame",
      "changeGame",
      "changeBackground",
      "finishGame",
    ]),
    onRestartClick() {
      this.restartGame();
    },
    onBackgroundChange() {
      this.changeBackground();
    },
    onPopitChange() {
      this.changeGame(this.items.every((item) => item.isActive === false));
      if (this.isGameFinished) {
        setTimeout(() => {
          this.$bvModal.show("popit-win-modal");
          this.finishGame();
        }, 1500);
      }
    },
    onPrizeClick() {
      this.$bvModal.show("prize-modal");
    },
  },
  computed: {
    ...mapState("popitModule", {
      items: (state) => state.items,
      isGameFinished: (state) => state.isGameFinished,
      currentBackground: (state) => state.currentBackground,
    }),
    ...mapGetters("popitModule", {
      isGameAlmostFinished: "isGameAlmostFinished",
      selectedBackground: "selectedBackground",
    }),
  },
};
</script>

<style scoped lang="scss">
.popit {
  height: 100%;
  width: 100%;
  max-height: 100vh;
  position: relative;
  z-index: 1;
  overflow: hidden;

  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    background-image: url("@/assets/png/home-bg@1920.png");
    background-repeat: no-repeat;
    background-size: cover;
    height: 100%;
    width: 100%;
    max-height: 100vh;
    backdrop-filter: blur(20px);
    filter: blur(8px);
    z-index: 0;
    transition: filter 0.7s 0.7s, background-image 0.7s 0.7s;

    @media (max-width: 1500px) {
      background-image: url("@/assets/png/home-bg.png");
    }

    @media (max-width: 999px) {
      background-image: url("@/assets/png/home-bg-mob.png");
    }

    &.m-finish {
      filter: none;
    }
  }

  &__content {
    z-index: 1;
    position: relative;
    width: 100%;
    margin-bottom: 56px;
    height: 100%;
    display: grid;
    grid-template-rows: auto 1fr auto;
    align-items: center;
    justify-content: center;

    @media (max-width: 999px) {
      padding-top: 175px;
      grid-template-rows: 1fr auto;
    }

    @media (max-width: 499px) {
      padding-top: 56px;
    }
  }

  &__title {
    color: $white;
    margin-left: auto;
    margin-right: 80px;
    margin-bottom: 36px;
    z-index: 1;
    width: 100%;
    text-align: right;

    @media (max-width: 999px) {
      display: none;
    }
  }

  &__game {
    margin-bottom: 41px;
    height: 100%;
    display: flex;
    align-items: center;

    @media (max-width: 1439px) {
      margin-bottom: 21px;
    }
  }

  &__buttons {
    margin-top: auto;
    display: flex;
    gap: 35px;
    justify-content: center;
    margin-bottom: 99px;

    @media (max-width: 999px) {
      margin-bottom: 56px;
    }
  }
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
